import {Tooltip} from '@mui/material'
import {differenceInMinutes} from 'date-fns'
import {EdgeServersDTO} from 'src/services/api'

type Props = {
  server: EdgeServersDTO
}

export default function StatusIcon({server}: Props) {
  const lastConnectedDate = new Date(server.lastConnectedAt)
  const differenceInMinutesOnConnection = differenceInMinutes(new Date(), lastConnectedDate)
  const hasCompany = !!server.companyId
  const hasClient = !!server.clientId

  const statusOnline = differenceInMinutesOnConnection <= 1 && hasCompany && hasClient
  const statusOffline = differenceInMinutesOnConnection > 1 && hasCompany && hasClient
  const missingConfig = differenceInMinutesOnConnection <= 1 && !hasCompany && !hasClient

  return (
    <Tooltip
      title={
        statusOnline
          ? 'Servidor online'
          : statusOffline
            ? 'Servidor offline'
            : missingConfig
              ? 'Servidor online — configuração pendente'
              : 'Servidor offline — configuração pendente'
      }
      placement='top'>
      <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='8' cy='8' r='8' fill={statusOnline ? '#039855' : statusOffline ? '#D92D20' : missingConfig ? '#F79009' : '#C2C2C2'} />
      </svg>
    </Tooltip>
  )
}
